export const environment = {
  production: false,
  console: true,
  API_URL: "https://apides.apiacpos.com/api_bridge/api/",  
  CODIGO_APLICACION: "CUSTOMAN",
  ID_APLICACION: "19",
  chClaveEmpresa: "THYSSENMADRID",
  TICKETS_URL: "https://tickamore.webventa.iacposdes.com/thyssen",
  chProyectoOnLine: "VENTAONLINE",
  chEntornoConexion: "DESARROLLO",
  chNombreProyecto: "CUSTOMMAN",
  chOrigenConexion: "CUSTOMMAN",
  NUMSERIE: "CUSTO$A$SZ45$A$MMAN$A$23g!.",
  API_MICROSERVICIOS: "https://apides.apiacpos.com/WebAPICoreBridge",
  VALIDATE_PERMISSIONS: false,
};
